import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import AddressForm from "./AddressForm";
import I18n from 'i18n.js.erb'

const AddressFormContainerModal = ({
    showModal,
    setShowModal,
    shipmentAddress,
    updateShipmentAddressParams,
    countries,
    updateShipmentAddress,
    createNewAddress,
    canUpdate,
    addressType
  }) => {

  const [ formSubmitted, setFormSubmitted ] = useState(false);

  useEffect(() => {
    if (!showModal)
      setFormSubmitted(false);
  }, [showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
  }

  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={handleCloseModal}
      animation={false}
    >
      <Modal.Header>
        <Modal.Title>{createNewAddress ? I18n.t('js.updateUserAddressModal.createTitle') : I18n.t('js.updateUserAddressModal.updateTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddressForm
          shipmentAddress={shipmentAddress}
          updateShipmentAddressParams={updateShipmentAddressParams}
          countries={countries}
          canUpdate={canUpdate}
          addressType={addressType}
          formSubmitted={formSubmitted}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized text-weight-500"
          onClick={handleCloseModal}
        >
          {I18n.t('js.common.button.cancel').toUpperCase()}
        </button>
        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px text-weight-500"
          onClick={(e) => {
            setFormSubmitted(true);
            updateShipmentAddress();
          } }
        >
          {I18n.t('js.common.button.save').toUpperCase()}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddressFormContainerModal;